<div class="card add-margin">
  <div *ngIf="usuariosNivel.length > 0">
    <table id="tablaNivelSeleccionado" class="table table-xl table-striped table-hover menu-izq">
      <thead class="text-center letra">
        <tr>
          <th scope="col"> Usuario </th>
          <th scope="col"> Desde </th>
          <th scope="col"> Hasta</th>
          <th scope="col"> Otorgado por </th>
          <th scope="col"> Eliminar </th>
        </tr>
      </thead>

      <tbody class="text-center">
        <tr style="font-size: 13px;" *ngFor="let usuario of usuariosNivel; let i=index ">
          <td> {{usuario.usuario.nombresCompletos}}</td>
          <td> {{usuario.fechaDesde | date: 'dd/MM/yyyy' }}</td>
          <td> {{usuario.fechaHasta ? (usuario.fechaHasta | date: 'dd/MM/yyyy') : "-"}}</td>
          <td> {{usuario.fechaHasta ? usuario.otorgadoPor?.nombresCompletos : "Nativo"}}</td>
          <td>
            <button [disabled]="eliminandoUsuario !== null" class="btn btn-danger" (click)="borrarUsuario(i)"><i *ngIf="eliminandoUsuario !== i" class="fa fa-trash"></i>
              <div *ngIf="eliminandoUsuario == i" class="d-flex align-items-center"> 
                <div class="spinner-border text-light spinner-border-sm" role="status"></div>
              </div>
            </button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>

  <ngb-alert *ngIf="usuariosNivel.length == 0" [dismissible]="false" type="warning" class="alert alert warning">
    No existen usuarios para el nivel seleccionado
  </ngb-alert>
</div>